import { DropdownMenu, DropdownMenuItem } from '../../dropdownMenu/DropdownMenu'

type RowActionsProps = {
  /** Accessible name of the "more actions" button. */
  label: string
  items: DropdownMenuItem[]
  disabled?: boolean
}

/**
 * The actions of a list item, the same in table rows and cards: a compact "more actions" menu, or nothing when there
 * is nothing to do. Clicks stay inside the menu, so a clickable row does not open as well.
 */
export const RowActions = ({ label, items, disabled = false }: RowActionsProps) =>
  items.length === 0 ? null : (
    <div className="row-actions" onClick={event => event.stopPropagation()}>
      <DropdownMenu label={label} items={items} disabled={disabled} />
    </div>
  )
